import { createFileRoute } from '@tanstack/react-router'
import { BudgetScreen } from '@/features/budget/BudgetScreen'

export const Route = createFileRoute('/budget')({
  component: BudgetScreen,
})
